import { create } from 'zustand';

/** One generated worksheet (matches the API's EddSheet shape). */
export interface EddSheetData {
  sheetName: string;
  columns: string[];
  rows: (string | null)[][];
}

/** The result of an EDD generate — handed from the "EDD Report Query" popup to
 *  the separate Spreadsheet View (Univer) page.  Kept in a tiny store rather
 *  than the URL so the (potentially large) sheet data survives the AppShell
 *  page switch without re-fetching. */
export interface EddResult {
  /** Empty until the user clicks Save (preview does not persist). */
  eddReportId: string;
  eddReportOid: string;
  templateName: string;
  sheets: EddSheetData[];
  /** Kept so the Spreadsheet View's Save button can re-run + persist. */
  templateId: string;
  filter: unknown;
  saved: boolean;
}

interface EddResultState {
  result: EddResult | null;
  setResult: (r: EddResult | null) => void;
}

export const useEddResultStore = create<EddResultState>((set) => ({
  result: null,
  setResult: (result) => set({ result }),
}));
